import { render, staticRenderFns } from "./LoanSubCategory.vue?vue&type=template&id=6a70da1f"
import script from "./LoanSubCategory.vue?vue&type=script&lang=js"
export * from "./LoanSubCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports